/*
 * Page Name
 */

jQuery(document).ready(function () {
    jQuery('.application_infor_tab').on('click', '._tabs', function () {
        const $this = jQuery(this);
        const target = '#' + $this.data('tab');

        $this
            .addClass('is-active')
            .siblings()
            .removeClass('is-active');

        jQuery(target)
            .addClass('is-active')
            .siblings('.application_infor_panel')
            .removeClass('is-active');
    });
});